<template>
  <header>
    <div class="container">
      <img src="../assets/images/logo.png" alt @click="setHomePage" class="logo" />
      <h3 @click="setHomePage">{{title}}</h3>
      <img :src="require(`../assets/images/${$logo}`)" alt @click="setHomePage" class="logo" />
    </div>
  </header>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "Header",
  methods: {
    ...mapMutations(["setHomePage"]),
    changeCssForPN() {
      if (document.title === "Pakiet niezawodny") {
        const container = document.querySelector(".container");
        const title = document.querySelector(".container h3");
        title.classList.add("for-pn-title");
        container.classList.add("for-pn");
      }
    },
  },
  computed: {
    title() {
      return document.title;
    },
  },
  mounted() {
    this.changeCssForPN();
  },
};
</script>

<style scoped lang="scss">
header {
  position: fixed;
  width: 100%;
  background: #fff;
  left: 0;
}
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 816px) {
    padding: 8px 16px;
  }
}
.for-pn {
  @media screen and (max-width: 470px) {
    padding: 8px 16px 25px;
  }
}

img {
  cursor: pointer;
  max-height: 56px;
}
h3 {
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: #454545;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  cursor: pointer;
  @media screen and (max-width: 816px) {
    font-size: 16px;
    line-height: 25px;
  }
}
.for-pn-title {
  @media screen and (max-width: 470px) {
    top: 60px;
  }
}
.logo {
  max-height: 40px;
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue